import { AUTH_URI } from "shared/constants/uri";
import get from "lodash/get";

interface IGetRedirectionURLForSamePageProps {
    url: string;
    search: string;
    pathname: string;
}

interface IGetRedirectionURLWithRefererProps {
    url: string;
    redirectUrl: string;
}

export const getRedirectionURLWithCurrentPage = ({
    url,
    search,
    pathname,
}: IGetRedirectionURLForSamePageProps) => {
    const params = new URLSearchParams();
    params.set("redirectURL", (pathname + search).replace("?", "@"));

    return AUTH_URI.PATH + url + "&" + params.toString();
};

export const getRedirectionURLWithReferer = ({
    url,
    redirectUrl,
}: IGetRedirectionURLWithRefererProps) => {
    const params = new URLSearchParams();

    params.set("redirectURL", redirectUrl);

    return AUTH_URI.PATH + url + "&" + params.toString();
};

export const getUserDetailsToStore = res => {
    const userDetails = get(res, "response.user", {});
    let userDetailsToStore = {};

    // remove the empty values before sending it to store.
    Object.keys(userDetails).forEach((key: string) => {
        if (userDetails[key] !== null) {
            userDetailsToStore[key] = userDetails[key];
        }
    });

    return userDetailsToStore;
};
